import { useCallback, useState } from 'react';

export type VariablesState = Record<string, string | undefined> & {
  processId?: string;
  robotId?: string;
  processRunId?: string;
  robotRunId?: string;
  workItemId?: string;
  robotTask?: string;
  artifactId?: string;
  fileName?: string;
  fileId?: string;
  apiKey?: string;
  assistantId?: string;
  environmentId?: string;
  environmentGroupId?: string;
  linkTokenId?: string;
};
/**
 * API helper variable hook to read and set the target API call endpoint parts
 *
 * @example
 *
 * const [variables, setVariables] = useVariables();
 */
export const useVariables = (): [VariablesState, (value: VariablesState) => void] => {
  const [state, setState] = useState({});

  const setVariables = useCallback(
    (value: VariablesState) => setState({ ...state, ...value }),
    [state],
  );

  return [state, setVariables];
};
